import { useLocation } from "react-router-dom";

import { useAppSelector } from "app/hooks";
import InsertScribeDialog from "features/patients/sections/patient-chart-notes/insert-scribe-dialog/insert-scribe-dialog.component";
import { showInsertScribeForChartNoteId } from "features/patients/sections/patient-chart-notes/patient-chart-notes.slice";

import { getPatientIdFromPathname } from "../utils";

export default function InsertScribeDialogHost() {
  const location = useLocation();
  const patientId = getPatientIdFromPathname(location.pathname);
  const { show } = useAppSelector(showInsertScribeForChartNoteId);

  if (!show || !patientId) {
    return null;
  }

  return <InsertScribeDialog patientId={Number(patientId)} />;
}
